module.exports = __webpack_public_path__ + "img/vi_VN.3f718c3.webp";